export const MAIN_CLASS_NAME = 'artifact-list-title';
export const TITLE_TOP_ROW_CLASS_NAME = `${MAIN_CLASS_NAME}__top-row`;
